import { useAppDispatch, useAppSelector } from "@app/hooks";
import { setParamsThemeSetting } from "@features/main/store/dynamicSlice";
import { dataService } from "@share/configs/rxjs";
import FloatingPanelComponent from "@share/components/FloatingPanel";
import { convertRGBAStringColor, rgbaToHex } from "@share/lib";
import { Collapse } from "antd-mobile";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ColorPicker, { ColorPickerV2 } from "../../../ColorPicker";
import { GENERAL_SETTING_DEFAULT_VALUE } from "@share/configs/const";
import DisplayColor from "@share/components/DisplayColor";
import PopupComponent from "@share/components/PopupComponent";
import { DropDownIcon1, DropDownIcon2 } from "@share/icons";

type Props = {
  onUpdateColor: (color) => void;
  onUpdateSecondColor: (color) => void;
};

interface data {
  selectedMainColor: string;
}

const ColorIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="22"
      height="22"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M6.80458 14.246C6.63385 14.4178 6.53802 14.6501 6.53802 14.8923C6.53802 15.1344 6.63385 15.3668 6.80458 15.5385C6.8898 15.6244 6.99118 15.6926 7.10289 15.7392C7.21459 15.7857 7.33441 15.8097 7.45542 15.8097C7.57643 15.8097 7.69624 15.7857 7.80795 15.7392C7.91965 15.6926 8.02104 15.6244 8.10625 15.5385C8.27698 15.3668 8.37281 15.1344 8.37281 14.8923C8.37281 14.6501 8.27698 14.4178 8.10625 14.246C8.02104 14.1601 7.91965 14.0919 7.80795 14.0454C7.69624 13.9988 7.57643 13.9749 7.45542 13.9749C7.33441 13.9749 7.21459 13.9988 7.10289 14.0454C6.99118 14.0919 6.8898 14.1601 6.80458 14.246ZM6.80458 6.4635C6.63385 6.63525 6.53802 6.86758 6.53802 7.10975C6.53802 7.35192 6.63385 7.58425 6.80458 7.756C6.8898 7.84192 6.99118 7.91011 7.10289 7.95665C7.21459 8.00319 7.33441 8.02715 7.45542 8.02715C7.57643 8.02715 7.69624 8.00319 7.80795 7.95665C7.91965 7.91011 8.02104 7.84192 8.10625 7.756C8.27698 7.58425 8.37281 7.35192 8.37281 7.10975C8.37281 6.86758 8.27698 6.63525 8.10625 6.4635C8.02104 6.37758 7.91965 6.30939 7.80795 6.26285C7.69624 6.21631 7.57643 6.19235 7.45542 6.19235C7.33441 6.19235 7.21459 6.21631 7.10289 6.26285C6.99118 6.30939 6.8898 6.37758 6.80458 6.4635ZM11.3421 15.6302C11.1608 15.6302 10.9836 15.6839 10.8328 15.7847C10.6821 15.8854 10.5646 16.0285 10.4952 16.196C10.4258 16.3635 10.4077 16.5479 10.443 16.7257C10.4784 16.9035 10.5657 17.0668 10.6939 17.195C10.8221 17.3232 10.9854 17.4105 11.1633 17.4459C11.3411 17.4813 11.5254 17.4631 11.6929 17.3937C11.8604 17.3243 12.0035 17.2069 12.1043 17.0561C12.205 16.9054 12.2587 16.7281 12.2587 16.5468C12.265 16.4227 12.2459 16.2985 12.2026 16.182C12.1593 16.0654 12.0928 15.9589 12.007 15.8688C11.9213 15.7788 11.8181 15.7071 11.7038 15.6582C11.5895 15.6093 11.4664 15.5842 11.3421 15.5843V15.6302ZM5.84208 10.1302C5.66078 10.1302 5.48356 10.1839 5.33281 10.2847C5.18207 10.3854 5.06457 10.5285 4.99519 10.696C4.92581 10.8635 4.90766 11.0479 4.94303 11.2257C4.9784 11.4035 5.06571 11.5668 5.1939 11.695C5.3221 11.8232 5.48544 11.9105 5.66325 11.9459C5.84107 11.9813 6.02538 11.9631 6.19288 11.8937C6.36038 11.8243 6.50354 11.7069 6.60426 11.5561C6.70499 11.4054 6.75875 11.2281 6.75875 11.0468C6.76497 10.9227 6.74586 10.7985 6.70258 10.6819C6.65931 10.5654 6.59277 10.4589 6.50702 10.3688C6.42128 10.2788 6.31811 10.2071 6.2038 10.1582C6.08948 10.1093 5.96642 10.0842 5.84208 10.0843V10.1302ZM11.3421 4.63017C11.1608 4.63017 10.9836 4.68393 10.8328 4.78465C10.6821 4.88538 10.5646 5.02854 10.4952 5.19604C10.4258 5.36354 10.4077 5.54785 10.443 5.72567C10.4784 5.90348 10.5657 6.06682 10.6939 6.19502C10.8221 6.32321 10.9854 6.41052 11.1633 6.44589C11.3411 6.48126 11.5254 6.4631 11.6929 6.39372C11.8604 6.32434 12.0035 6.20685 12.1043 6.05611C12.205 5.90536 12.2587 5.72813 12.2587 5.54684C12.265 5.42266 12.2459 5.29851 12.2026 5.18195C12.1593 5.06539 12.0928 4.95885 12.007 4.86882C11.9213 4.77878 11.8181 4.70713 11.7038 4.65823C11.5895 4.60932 11.4664 4.58418 11.3421 4.58434V4.63017ZM14.5871 6.50934C14.4583 6.63731 14.3705 6.80064 14.3347 6.9786C14.2989 7.15657 14.3167 7.34116 14.3859 7.50898C14.4551 7.67679 14.5726 7.82028 14.7235 7.92124C14.8744 8.02221 15.0518 8.07611 15.2333 8.07611C15.4149 8.07611 15.5923 8.02221 15.7432 7.92124C15.894 7.82028 16.0115 7.67679 16.0807 7.50898C16.15 7.34116 16.1678 7.15657 16.132 6.9786C16.0962 6.80064 16.0083 6.63731 15.8796 6.50934C15.714 6.33238 15.485 6.22821 15.2428 6.21962C15.0006 6.21103 14.7648 6.29872 14.5871 6.4635V6.50934ZM20.3621 6.50934C19.524 4.83394 18.2358 3.42514 16.6419 2.44089C15.048 1.45665 13.2114 0.935894 11.3381 0.937014C9.46474 0.938133 7.62878 1.46109 6.03604 2.44723C4.4433 3.43338 3.15676 4.84372 2.32069 6.52012C1.48462 8.19651 1.13209 10.0727 1.30261 11.9382C1.47313 13.8037 2.15997 15.5849 3.28611 17.0819C4.41225 18.579 5.93316 19.7327 7.6783 20.4137C9.42343 21.0948 11.3238 21.2762 13.1663 20.9377C13.6296 20.8505 14.0709 20.6718 14.4644 20.4121C14.8578 20.1524 15.1956 19.8169 15.4579 19.4252C15.7406 18.9993 15.9356 18.5214 16.0316 18.0193C16.1276 17.5173 16.1227 17.0011 16.0171 16.501C15.9594 16.1988 15.9287 15.892 15.9254 15.5843C15.9294 14.696 16.1915 13.8281 16.6797 13.086C17.1679 12.3439 17.8613 11.7596 18.6754 11.4043C19.1144 11.2078 19.5084 10.9234 19.8332 10.5686C20.158 10.2139 20.4066 9.79639 20.5638 9.34183C20.7227 8.87735 20.7868 8.38567 20.7521 7.89596C20.7175 7.40625 20.5848 6.92849 20.3621 6.491V6.50934ZM18.8038 8.746C18.7255 8.96538 18.6041 9.16683 18.4466 9.33845C18.2892 9.51008 18.0989 9.64837 17.8871 9.74517C16.7596 10.2499 15.8017 11.0693 15.1285 12.1051C14.4553 13.1409 14.0955 14.349 14.0921 15.5843C14.0934 16.0152 14.1364 16.445 14.2204 16.8677C14.2764 17.126 14.2801 17.3929 14.2313 17.6527C14.1825 17.9124 14.0822 18.1598 13.9362 18.3802C13.8128 18.573 13.6503 18.7379 13.4593 18.8642C13.2683 18.9905 13.0529 19.0754 12.8271 19.1135C12.3375 19.2055 11.8403 19.2515 11.3421 19.251C10.2367 19.2515 9.14256 19.0299 8.12452 18.5994C7.10647 18.1688 6.18533 17.5381 5.4158 16.7446C4.64626 15.9511 4.04403 15.0111 3.64485 13.9804C3.24567 12.9496 3.0577 11.8491 3.09208 10.7443C3.16323 8.68439 3.99867 6.72471 5.43566 5.24705C6.87265 3.76939 8.80826 2.87959 10.8654 2.751H11.3329C12.869 2.75139 14.3745 3.18063 15.6799 3.9904C16.9852 4.80016 18.0385 5.95828 18.7213 7.33434C18.9314 7.76973 18.961 8.27051 18.8038 8.72767V8.746ZM11.3421 10.0843C11.1608 10.0843 10.9836 10.1381 10.8328 10.2388C10.6821 10.3395 10.5646 10.4827 10.4952 10.6502C10.4258 10.8177 10.4077 11.002 10.443 11.1798C10.4784 11.3576 10.5657 11.521 10.6939 11.6492C10.8221 11.7774 10.9854 11.8647 11.1633 11.9001C11.3411 11.9354 11.5254 11.9173 11.6929 11.8479C11.8604 11.7785 12.0035 11.661 12.1043 11.5103C12.205 11.3595 12.2587 11.1823 12.2587 11.001C12.2587 10.7579 12.1622 10.5247 11.9903 10.3528C11.8184 10.1809 11.5852 10.0843 11.3421 10.0843Z"
      fill="#333333"
    />
  </svg>
);
const PrimaryColor = (props: Props) => {
  const { onUpdateColor, onUpdateSecondColor } = props;
  const siteSettings = useAppSelector<any>((state) => state.siteSettings);

  const { t } = useTranslation();

  const displaySettings =
    siteSettings &&
    Object.values(siteSettings).length > 0 &&
    siteSettings.display_setting;
  const {
    primary_color = GENERAL_SETTING_DEFAULT_VALUE.PRIMARY_COLOR,
    second_color = GENERAL_SETTING_DEFAULT_VALUE.SECONDARY_COLOR,
  } = displaySettings;

  const [mainColorState, setMainColorState] = useState(primary_color);
  const [secondColorState, setSecondColorState] = useState(second_color);
  const [isOpenColorPicker, setIsOpenColorPicker] = useState(false);
  const [isOpenSecondColorPicker, setIsOpenSecondColorPicker] = useState(false);

  useEffect(() => {
    const subscription = dataService.getObservable().subscribe((data: data) => {
      if (data) {
        const selectedMainColor = data.selectedMainColor;
        if (selectedMainColor) {
          setMainColorState(selectedMainColor);
        }
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    onUpdateColor(mainColorState);
  }, [mainColorState]);

  useEffect(() => {
    onUpdateSecondColor(secondColorState);
  }, [secondColorState]);

  return (
    <>
      <div>
        <Collapse
          defaultActiveKey={["1"]}
          arrow={(active) => (active ? <DropDownIcon1 /> : <DropDownIcon2 />)}
        >
          <Collapse.Panel
            key="1"
            title={
              <>
                <div className="flex">
                  <span className="mr-1">
                    <ColorIcon />
                  </span>
                  <span>{t("ss_builder_theme_setting_primary_color")}</span>
                </div>
              </>
            }
          >
            <div className="flex mb-3">
              <div className="mr-3 text-center">
                <div className="m-auto mb-1">
                  <DisplayColor
                    backgroundColor={mainColorState}
                    onClickOpenColorPicker={setIsOpenColorPicker}
                  />
                </div>
                <div className="text-sm mb-4 text-black">
                  {t("ss_builder_block_main_color")}
                </div>
              </div>
              <div className="mr-3 text-center">
                <div className="m-auto mb-1">
                  <DisplayColor
                    backgroundColor={secondColorState}
                    onClickOpenColorPicker={setIsOpenSecondColorPicker}
                  />
                </div>

                <div className="text-sm mb-4 text-black">
                  {t("ss_builder_block_second_color")}
                </div>
              </div>
            </div>
          </Collapse.Panel>
        </Collapse>
      </div>
      <PopupComponent
        visible={isOpenColorPicker}
        onMaskClick={() => setIsOpenColorPicker(false)}
        title={t("ss_builder_color_picker_panel_title")}
        onClose={() => setIsOpenColorPicker(false)}
        classNameBody="h-[60vh] popup-hard"
      >
        <ColorPickerV2
          defaultColor={mainColorState}
          onCancel={() => setIsOpenColorPicker(false)}
          onColorSelected={(data) => setMainColorState(data)}
        />
      </PopupComponent>
      <PopupComponent
        visible={isOpenSecondColorPicker}
        onMaskClick={() => setIsOpenSecondColorPicker(false)}
        title={t("ss_builder_color_picker_panel_title")}
        onClose={() => setIsOpenSecondColorPicker(false)}
        classNameBody="h-[60vh] popup-hard"
      >
        <ColorPickerV2
          defaultColor={secondColorState}
          onCancel={() => setIsOpenSecondColorPicker(false)}
          onColorSelected={(data) => setSecondColorState(data)}
        />
      </PopupComponent>
    </>
  );
};

export default PrimaryColor;
